import React, { Component } from'react';
import './App.css';
// import './custom.js';

// import "../components/EpicfinanceTremds.css"
// import{ ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, Tooltip } from 'recharts'
// import { PieChart, Pie, Cell} from 'recharts';
import { BrowserRouter, Route, Switch, HashRouter, Redirect } from 'react-router-dom';
import Header from './Header'; //Include Header;
import Footer from './Footer'; //Include Footer;
import AppHome from './App-home'; //Include Footer;
import Home from './components/Home';
import EpicUKEquityMarketComp from './components/EpicUKEquityMarketFund';

import EpicMultiAssetBalancedComp from './components/EpicMultiAssetBalanced';
import EpicNfaUcitsComponent from './components/EpicNfaUcits';
import EpicInsightsComponent from './components/EpicNews'
import EpicInsightsDataComponent from './components/EpicNewsData'
import EpicDailyUpdateComponent from './components/EpicDailyUpdate'
import EpicDailyUpdateDataComponent from './components/EpicDailyUpdateData'
// import EpicDFMComponent from './components/EpicDfm'
import EpicDFMComponentNew from './components/EpicDfmlandingpage'
import RiskEpicDFMComponent from './components/RiskEpicDFM'

//import AIMPortfolioDFMComponent from './components/AIMPortfolioDFM'
import AIMPortfolioDFMComponent from './components/AIMPortfolioDFMFund'
import RiskTargetedDFMComponent from './components/RiskTargetedDFM'
import NotFoundComponent from './components/NotFound'
import EpicPCCNextGenComponent from './components/EpicPCCNextGen';
import EpicRNBpccComponent from './components/EpicRNBpcc';

import FixedIncomeComponent from './components/FixedIncomeLogin';

import EpicInsightsLandingComponent from './components/InsightsLanding';



export default function App() {

  return (
  
  <BrowserRouter >
    <div className="maincontainer">
     <Header></Header>
    
      <Switch>

      <Route path="/markets"  component={Home} exact/>
      <Route path="/markets/EpicfinanceTrends" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/EpicglobalEquity" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/EpicorientalFocus" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/EpicAsianCentricGlobalGrowth" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/EpicUKEquityMarketFund" component={EpicUKEquityMarketComp}/>       
      <Route path="/markets/EpicipWealthFund" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/EpicipMultiAssetFund" component={EpicMultiAssetBalancedComp}/> 
      <Route path="/markets/EpicipMultiAssetGrowthFund" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/EpiciNfaUcitsFundRoute" component={EpicNfaUcitsComponent}/>   
      <Route path="/markets/EpicNextGenUcitsFundRoute" render={() => <Redirect to="/markets" />} />
      {/* <Route path="/markets/EpicDFM" component={EpicDFMComponent}/>  */}
      <Route path="/markets/EpicDFM" component={EpicDFMComponentNew}/>
      <Route path="/markets/RiskEpicDFM" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/RTM3" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/RTM5" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/RTM7" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/AIMPortfolioDFM" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/RiskTargetedDFM" component={RiskTargetedDFMComponent} /> 
      <Route path="/markets/EpicDailyUpdates" component={EpicDailyUpdateComponent}/>
      <Route path="/markets/DailyUpdatesData/:slug" component={EpicDailyUpdateDataComponent}/>
      <Route path="/markets/EpicInsights" component={EpicInsightsComponent}/> 
      <Route path="/markets/EpicInsightsData/:slug" component={EpicInsightsDataComponent}/> 
      <Route path="/public/markets/:slug" component={NotFoundComponent} />
      {/* <Route path="/public/markets/EpicDFM" EpicDFMcomponent={EpicDFMComponent} /> */}
      <Route path="/public/markets/EpicDFM" EpicDFMcomponent={EpicDFMComponentNew} />
      <Route path="/public/markets/RiskEpicDFM" RiskEpicDFMComponent={RiskEpicDFMComponent} />
      <Route path="/public/markets/AIMPortfolioDFM" AIMPortfolioDFMComponent={AIMPortfolioDFMComponent} />
      <Route path="/public/markets/RiskTargetedDFM" RiskTargetedDFMComponent={RiskTargetedDFMComponent} />
      <Route path="/markets/EpicNextGenPCC" component={EpicPCCNextGenComponent}/> 
      <Route path="/markets/EpicRNBpcc" component={EpicRNBpccComponent}/> 
      <Route path="/markets/Epic-FixedIncome" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/FixedIncome" component={FixedIncomeComponent}/>  
      <Route path="/markets/SegregatedMandates" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/Epic-ManagedFutures" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/Epic-Equitites" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/Epic-MultiAsset" render={() => <Redirect to="/markets" />} />
      <Route path="/markets/Epic-Insights" component={EpicInsightsLandingComponent}/>
      <Route path="/markets/Hedge-Funds" render={() => <Redirect to="/markets" />} />
      
      {/* Catch-all route for 404 - must be last, only for /markets/* paths */}
      <Route path="/markets/*" component={NotFoundComponent} />
      
    </Switch> 
    
     <Footer></Footer>
     <script src="https://code.jquery.com/jquery-3.4.1.slim.min.js" integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n" crossOrigin="anonymous"></script>

     </div>
  </BrowserRouter>

  );
}







